import { useRef, useEffect } from 'react'

export const ChoiceOption = ({
  focus,
  text = '',
  onChange,
  onDelete,
  onEnter,
  onFocus,
  onPaste,
  placeholder,
}) => {
  const inputRef = useRef()
  const change = ({ target = {} }) => {
    const { value } = target
    onChange(value)
  }

  useEffect(() => {
    if (focus) {
      const { current } = inputRef
      current.focus()
    }
  }, [inputRef, focus])

  const remove = ({ key }) => {
    if (key === 'Enter') {
      const { current = {} } = inputRef
      current.blur()
      onEnter()
    }

    if (key === 'Backspace' && !text) {
      onDelete()
    }
  }

  return (
    <input
      ref={inputRef}
      onFocus={onFocus}
      placeholder={placeholder}
      onKeyDown={remove}
      onChange={change}
      onPaste={onPaste}
      value={text}
      type="text"
      className="option--input input--placeholder input__text input"
    />
  )
}
